import PropTypes from "prop-types"
import React, { useState } from "react"
import Select from "react-select"
import * as ClassNames from "classnames"
import _get from "lodash/get"

import ThemeConsumer from "shared/components/ThemeConsumer"

import customStyles from "./styles.css"

const SelectSearchable = ({
  theme,
  field,
  form,
  label,
  options,
  isSearchable,
  isClearable,
  noOptionsMessage,
  styles,
  margin,
  onChange,
  required,
  isDisabled,
  value,
  classNames,
  ...props
}) => {
  const [isSearching, setIsSearching] = useState(false)
  const selectedValue = options.find(
    (option) => option.value === field.value || option.value === value
  )
  const error = form.errors[field.name]
  const marginClass = theme[`margin_${margin}`]
  return (
    <div
      className={ClassNames(
        marginClass,
        customStyles.container,
        _get(classNames, "container", ""),
        {
          [theme.invalid]: error
        }
      )}
    >
      <Select
        {...props}
        name={field.name}
        options={options}
        value={selectedValue || value}
        noOptionsMessage={noOptionsMessage}
        onChange={(value) => {
          form.setFieldValue(field.name, value)
          if (onChange) onChange(value)
        }}
        invalid={!!error}
        error={error}
        isDisabled={isDisabled}
        onInputChange={(inputValue) => setIsSearching(inputValue)}
        styles={{
          control: (base, state) => ({
            ...base,
            padding: "5px 6px",
            borderRadius: "8px",
            borderColor: state.isDisabled ? "#B4BEDE" : "#C1C1C2",
            boxShadow: "none",
            "&:hover": {
              borderColor: "#646E6E"
            },
            backgroundColor: state.isDisabled
              ? "transparent"
              : base.backgroundColor,
            ...styles.control
          }),
          indicatorSeparator: () => ({
            display: "none",
            ...styles.indicatorSeparator
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
              ? "#0a645a"
              : base.backgroundColor,
            color: state.isSelected ? "white" : base.color,
            "&:hover": {
              backgroundColor: state.isSelected ? "#0a645a" : "#eee",
              color: state.isSelected ? "white" : "black"
            },
            ...styles.option
          }),
          menu: (base) => ({
            ...base,
            ...styles.menu
          }),
          menuList: (base) => ({
            ...base,
            ...styles.menuList
          }),
          placeholder: (base) => ({
            ...base,
            ...styles.placeholder
          })
        }}
      />

      <label
        className={ClassNames(customStyles.label, {
          [customStyles.labelFloat]: !!selectedValue,
          [customStyles.labelError]: error,
          [customStyles.labelDisabled]: isDisabled,
          [customStyles.labelHide]: isSearching && !selectedValue
        })}
      >
        {label}
        {required && !!selectedValue && (
          <span style={{ color: "red" }}> *</span>
        )}
      </label>
      {error && (
        <span className={ClassNames(theme.error, customStyles.span)}>
          {error}
        </span>
      )}
    </div>
  )
}

SelectSearchable.propTypes = {
  theme: PropTypes.shape({
    containerSelect: PropTypes.string,
    containerSpan: PropTypes.string,
    spanSelect: PropTypes.string,
    error: PropTypes.string,
    label: PropTypes.string,
    invalid: PropTypes.string
  }),
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.array.isRequired,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  noOptionsMessage: PropTypes.func,
  styles: PropTypes.object,
  margin: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  classNames: PropTypes.object
}

SelectSearchable.defaultProps = {
  field: {},
  form: {},
  label: "",
  value: "",
  options: [],
  isSearchable: true,
  isClearable: true,
  isDisabled: false,
  noOptionsMessage: () => "Nenhuma opção encontrada",
  styles: {},
  required: false,
  classNames: {}
}

export default ThemeConsumer("UIModernSelect")(SelectSearchable)



// WEBPACK FOOTER //
// ./src/shared/components/SelectSearchable/index.js